<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="姓名、电话、身份证号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-cascader
          v-model="state.withholding_agent_uid"
          :options="state.withholding_agent_data"
          :props="{ value: 'uid', label: 'name' }"
          style="width: 300px"
          placeholder="扣缴义务人"
          filterable
          clearable
          @change="onWithholdingAgentChange"
          @clear="
            delete state.params.withholding_agent_type;
            delete state.params.withholding_agent_id;
            delete state.withholding_agent_uid;
          "
        />
        <el-radio-group v-model="state.params.status" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="1">正常</el-radio-button>
          <el-radio-button :value="0">停用</el-radio-button>
        </el-radio-group>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <el-button type="primary" :icon="Plus" link @click="state.showAdd = true"
        >添加</el-button
      >
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        size="large"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />

        <el-table-column
          prop="name"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          width="120"
        />
        <el-table-column prop="phone" label="手机号" width="140">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="手机号"
              @click="$onCopy(row.phone)"
            >
              {{ row.phone }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="idcard" label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          :formatter="
            (row) =>
              $statusFormat({
                Text: row.status == 0 ? '停用' : '正常',
                Color: row.status == 0 ? '#f00' : '#1e90ff',
              })
          "
          :width="100"
        />
        <el-table-column prop="sex" label="性别" align="center" width="80">
          <template #default="{ row }">
            <text v-if="row.sex == '男'" style="color: #1e90ff">男</text>
            <text v-else-if="row.sex == '女'" style="color: #f00">女</text>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :min-width="200"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_name"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          :min-width="200"
        />
        <el-table-column
          label="操作"
          :width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="View"
              @click="
                $store.commit('openMenu', {
                  path: 'EmployeeDetail',
                  title: row.name,
                  refresh: true,
                  data: {
                    id: row.employee_id,
                  },
                })
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showAdd"
      title="添加员工"
      @close="state.showAdd = false"
    >
      <c_Add
        @close="
          state.showAdd = false;
          onLoad();
        "
        :customer_id="props.customer_id"
      ></c_Add>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customer_employee_list } from "@/http/customer";
import { data_withholdingagent_supplier_select } from "@/http/data";

import c_Add from "./Add.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  components: {
    c_Add,
  },
  props: {
    customer_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadWithholdingAgent();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      state.params.customer_id = props.customer_id;
      customer_employee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //加载扣缴义务人和供应商
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_supplier_select().then((res) => {
        if (res.status == 200) {
          const { withholdingAgent, supplier } = res.data.data;
          state.withholding_agent_data = [
            {
              uid: 0,
              name: "扣缴义务人",
              children: withholdingAgent.list.map((m) => {
                return { uid: "k_" + m.id, ...m };
              }),
            },
            {
              uid: 1,
              name: "供应商",
              children: supplier.list.map((m) => {
                return { uid: "g_" + m.id, ...m };
              }),
            },
          ];
        }
      });
    };

    //选择扣缴义务人
    const onWithholdingAgentChange = (value) => {
      if (value?.length == 2) {
        state.params.withholding_agent_type = value[0];
        state.params.withholding_agent_id = value[1].substring(2);
      }
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onWithholdingAgentChange,
      props,
    };
  },
};
</script>
<style scoped></style>
